module.exports = __webpack_public_path__ + "static/media/monthlysurvey.af784104.svg";